import { render } from "./DeletedMedicalInsurances.vue?vue&type=template&id=1cb3f2fa&scoped=true"
import script from "./DeletedMedicalInsurances.vue?vue&type=script&lang=js"
export * from "./DeletedMedicalInsurances.vue?vue&type=script&lang=js"

import "./DeletedMedicalInsurances.vue?vue&type=style&index=0&id=1cb3f2fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb3f2fa"]])

export default __exports__